import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import PlanerBtn from '../../atom/planer-btn/index.tsx'
import { trackMarketingEvent } from '../../../helpers/analytics.ts'
import { normalizeLanguage, withLang } from '../../../utils/langPath.ts'
import './index.css'

import heroImage from '../../../assets/weddingPlanner/817shots_so.png'

const WeddingPlanerHero: React.FC = () => {
	const navigate = useNavigate()
	const { t, i18n } = useTranslation('planner')
	const lang = normalizeLanguage(i18n.language)

	return (
		<section className='planer-hero-container'>
			<div className='planer-hero-background'>
				<img src={heroImage} alt='Wedding Planner' className='planer-hero-bg-image' />
				<div className='planer-hero-overlay' />
			</div>

			<div className='planer-hero-content'>
				<h1 className='planer-hero-title'>
					{t('landing.hero.title')}
				</h1>
				<p className='planer-hero-subtitle'>
					{t('landing.hero.subtitle')}
				</p>

				<PlanerBtn
					title={t('landing.hero.cta')}
					onClick={() => {
					trackMarketingEvent('cta_click', 'planner_hero_start')
					navigate(withLang(lang, '/weddingPlanner/login'))
				}}
					size='large'
				/>
			</div>
		</section>
	)
}

export default WeddingPlanerHero
